import { ArrowLeft, Phone, Star } from "lucide-react";
import { fmtDate } from "@/lib/constants";
import { BrandTag, StatusChip } from "@/components/common";
import { OutletStep } from "./OutletStep";
import { CustomerStep } from "./CustomerStep";
import { CloseStep } from "./CloseStep";

const Fact = ({ label, value }) => (
  <div><div className="text-xs text-slate-400">{label}</div><div className="text-sm font-medium text-slate-800">{value || "—"}</div></div>
);

export const TicketDetail = ({ t, meta, canEdit, onSaved, onBack }) => (
  <div data-testid="ticket-detail" className="space-y-4 fade-up">
    <button onClick={onBack} className="flex items-center gap-1 text-sm font-medium text-slate-500 hover:text-slate-900 lg:hidden" data-testid="ticket-back-button">
      <ArrowLeft className="h-4 w-4" /> All tickets
    </button>
    <div className="rounded-2xl border border-slate-200 bg-white p-5">
      <div className="flex flex-wrap items-start justify-between gap-3">
        <div>
          <div className="flex flex-wrap items-center gap-2"><BrandTag brand={t.brand} /><StatusChip status={t.status} testid="ticket-status" /></div>
          <h2 className="mt-2 font-display text-2xl font-bold text-slate-900" data-testid="ticket-customer-name">{t.customer_name || "Customer"}</h2>
          <p className="text-sm text-slate-500">{t.outlet} · {t.platform} · {fmtDate(t.date)}</p>
        </div>
        <a href={`tel:${t.customer_phone}`} data-testid="ticket-call-link" className="inline-flex h-11 items-center gap-2 rounded-xl bg-slate-900 px-4 text-sm font-semibold text-white transition-transform hover:-translate-y-0.5">
          <Phone className="h-4 w-4" />{t.customer_phone}
        </a>
      </div>
      <blockquote data-testid="ticket-feedback" className="mt-4 rounded-xl border-l-4 border-red-300 bg-red-50/50 p-4 text-[15px] text-slate-800">
        {t.text || <span className="text-slate-400">No written feedback</span>}
      </blockquote>
      <div className="mt-4 grid grid-cols-2 gap-4 sm:grid-cols-4">
        <Fact label="Rating" value={t.rating != null && <span className="inline-flex items-center gap-1">{t.rating}<Star className="h-3.5 w-3.5 fill-amber-400 text-amber-400" /></span>} />
        <Fact label="Category" value={t.category} />
        <Fact label="Bill / order no." value={t.ref_id} />
        <Fact label="Items" value={t.items} />
      </div>
    </div>
    <OutletStep t={t} canEdit={canEdit} onSaved={onSaved} />
    <CustomerStep t={t} meta={meta} canEdit={canEdit} onSaved={onSaved} />
    <CloseStep t={t} meta={meta} canEdit={canEdit} onSaved={onSaved} />
  </div>
);
